import digitalData from 'digital-data';

export const instantCheckout = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('instant-checkout.load', (payload) => {
    const { ICTemplate = '' } = payload?.output || {};
    const instantCheckoutDisplayed = ICTemplate === 'IC' ? 'y' : 'n';
    digitalData.content = digitalData.content || {};
    digitalData.content.feature = { instantCheckoutDisplayed };
  });
};